<p-scroll-panel class="h-full">
  <div [formGroup]="form">
    <table class="detail-table bordered">
      <tr>
        <td class="font-semibold" style="width: 200px">Indbetalings ID</td>
        <td style="width: 500px">{{ opkraevning()?.indbetalingsReference }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Reg nr.</td>
        <td>{{ opkraevningsListe()?.pengeinstitut?.regnr }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Status</td>
        <td>{{ opkraevning()?.indlaesningStatus }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Letsikring nr.</td>
        <td>{{ opkraevning()?.letsikringNr }}</td>
      </tr>
      <tr>
        <td class="font-semibold">CPR-nr.</td>
        <td>{{ opkraevning()?.cprNummer | cprNummer }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Betalingskonto</td>
        <td>
          {{ opkraevning()?.debiteringskonto?.regNr }}
          {{ opkraevning()?.debiteringskonto?.kontoNummer }}
        </td>
      </tr>
      @if (
        opkraevningsListe()?.pengeinstitut?.regnr === '7858' &&
        opkraevning()?.debiteringskonto?.skyggesaldoType
      ) {
        <tr>
          <td class="font-semibold">Skyggesaldo type</td>
          <td>
            {{ opkraevning()?.debiteringskonto?.skyggesaldoType }}
          </td>
        </tr>
      }
      <tr>
        <td class="font-semibold">Beløb</td>
        <td>{{ opkraevning()?.opkraevningsBeloeb | number: '1.2' }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Periode start</td>
        <td>{{ opkraevning()?.periodeStart | date: 'dd-MM-yyyy' }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Periode slut</td>
        <td>{{ opkraevning()?.periodeSlut | date: 'dd-MM-yyyy' }}</td>
      </tr>
      <tr>
        <td class="font-semibold">Modtager konto</td>
        <td>
          @if (opkraevning()?.krediteringskonto) {
            {{ opkraevning()?.krediteringskonto?.regNr }}
            {{ opkraevning()?.krediteringskonto?.kontoNummer }} ({{
              opkraevning()?.krediteringskonto?.navn
            }})
          }
        </td>
      </tr>
      <tr>
        <td class="font-semibold">Kommentar fra indlæsning</td>
        <td>{{ opkraevning()?.indlaesningKommentar }}</td>
      </tr>
    </table>
    <div class="flex mt-8">
      <div class="font-semibold" style="width: 200px">Kommentar til PI</div>
      @if (allowEdit()) {
        <textarea
          style="width: 500px"
          pTextarea
          formControlName="piKommentar"></textarea>
      } @else {
        <div>{{ opkraevning()?.piKommentar }}</div>
      }
    </div>
    <div class="font-semibold flex mt-8">
      <div style="width: 200px">Godkendt</div>
      @if (allowEdit()) {
        <p-checkbox [binary]="true" formControlName="godkendt" />
      } @else {
        <div>{{ opkraevning()?.godkendt | boolean }}</div>
      }
    </div>

    <div class="flex gap-4 mt-10">
      @if (allowEdit()) {
        <p-button
          label="Gem ændringer"
          icon="pi pi-save"
          (click)="onClickSave()"
          [disabled]="!form.valid" />
      }
      <p-button
        label="Tilbage"
        icon="pi pi-arrow-left"
        outlined
        (click)="onClickCancel()" />
    </div>
    @if (infoMessage()) {
      <div class="mt-2 p-2">
        <p-message [text]="infoMessage()" severity="info" />
      </div>
    }
  </div>
</p-scroll-panel>
